import type { AuditItem } from '../../../types/features/storeDetails/legacyAudits';

export const transformAuditToAuditItem = (audit: any): AuditItem => {
  const reportDatetime = audit.audit_date || audit.report_datetime || '';
  const auditSummary = audit.audit_summary || {};
  const revenue = auditSummary.total_revenue ?? auditSummary.revenue ?? audit.revenue ?? 0;
  const posSummary = audit.pos_summary || {};
  const scratcherCount = posSummary.scratcher_count ?? 0;

  return {
    audit_id: audit.audit_id || '',
    report_datetime: reportDatetime,
    user_name: audit.user_name || '',
    audits: 1,
    opening_count: auditSummary.opening_count ?? audit.opening_count ?? 0,
    newly_activated_count: auditSummary.newly_activated_count ?? audit.newly_activated_count ?? 0,
    moved_to_backstock_count: auditSummary.moved_to_backstock_count ?? audit.moved_to_backstock_count ?? 0,
    closing_count: auditSummary.closing_count ?? audit.closing_count ?? 0,
    total_sold: auditSummary.total_sold ?? audit.total_sold ?? 0,
    revenue,
    free_scratcher: 0,
    scratcher_payout: 0,
    lotto_payout: 0,
    total_payout: 0,
    scratcher_sold_qty: scratcherCount,
    scratcher_sold_amount: posSummary.scratcher_sales ?? 0,
    lotto_sold_amount: posSummary.lotto_sales ?? 0,
    total_amount: 0,
    pos_reported_payout: posSummary.payout ?? 0,
    pos_data: posSummary
      ? {
          pos_summary: {
            scratcher_quantity_sold: String(scratcherCount),
            scratcher_sales: String(posSummary.scratcher_sales ?? 0),
            lotto_sales: String(posSummary.lotto_sales ?? 0),
            payout: String(posSummary.payout ?? 0),
          },
        }
      : undefined,
    audit_summary: auditSummary ? { revenue } : undefined,
    lotto_summary: audit.lotto_summary
      ? {
          sales: audit.lotto_summary.sales ?? 0,
          payouts_total: audit.lotto_summary.payouts_total ?? 0,
          scratcher_free_tickets_paid_amount: audit.lotto_summary.scratcher_free_tickets_paid_amount ?? 0,
        }
      : undefined,
    reconciliation_variance: audit.reconciliation_variance
      ? {
          scratcher: audit.reconciliation_variance.scratcher
            ? {
                quantity_variance: audit.reconciliation_variance.scratcher.quantity_variance ?? 0,
                revenue_variance: audit.reconciliation_variance.scratcher.revenue_variance ?? 0,
              }
            : undefined,
          lotto_sales_variance: audit.reconciliation_variance.lotto_sales_variance ?? 0,
          payout_variance: audit.reconciliation_variance.payout_variance ?? 0,
          total_variance: audit.reconciliation_variance.total_variance ?? 0,
        }
      : undefined,
  };
};
